import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import cn from 'classnames';
import { createElement, ReactNode } from 'react';

import styles from './styles.module.scss';

type TypographyProps = WithLayoutType<{
  className?: string;
  tag: 'span' | 'div' | 'p';
  type: 'body' | 'bodyBold' | 'bodyLink';
  children: ReactNode;
}>;

export function BlogTypography(props: TypographyProps) {
  const { tag, className, layoutType, type, children } = props;

  return createElement(
    tag,
    {
      className: cn(styles.typography, className),
      'data-layout-type': layoutType,
      'data-type': type,
    },
    children,
  );
}
